import { RichText } from "@/components/RichText";

// Lightweight markdown renderer: #/##/### headings, - / * bullet lists, **bold**, *italic*.
export function Markdown({ text, className = "" }) {
  if (!text || !text.trim()) return <p className="text-slate-400">No content yet.</p>;
  const lines = text.split("\n");
  const blocks = [];
  let list = [];
  const flush = () => { if (list.length) { blocks.push({ type: "ul", items: [...list] }); list = []; } };
  lines.forEach((raw) => {
    const line = raw.replace(/\s+$/, "");
    if (/^\s*[-*]\s+/.test(line)) { list.push(line.replace(/^\s*[-*]\s+/, "")); return; }
    flush();
    if (/^###\s+/.test(line)) blocks.push({ type: "h3", text: line.replace(/^###\s+/, "") });
    else if (/^##\s+/.test(line)) blocks.push({ type: "h2", text: line.replace(/^##\s+/, "") });
    else if (/^#\s+/.test(line)) blocks.push({ type: "h1", text: line.replace(/^#\s+/, "") });
    else if (line.trim() === "") blocks.push({ type: "space" });
    else blocks.push({ type: "p", text: line });
  });
  flush();
  return (
    <div className={className}>
      {blocks.map((b, i) => {
        if (b.type === "h1") return <h2 key={i} className="mb-2 mt-6 font-heading text-2xl font-bold text-slate-900"><RichText text={b.text} /></h2>;
        if (b.type === "h2") return <h3 key={i} className="mb-2 mt-5 font-heading text-xl font-bold text-slate-900"><RichText text={b.text} /></h3>;
        if (b.type === "h3") return <h4 key={i} className="mb-1 mt-4 font-heading text-lg font-semibold text-slate-900"><RichText text={b.text} /></h4>;
        if (b.type === "ul") return <ul key={i} className="my-2 list-disc space-y-1 pl-6 text-slate-700">{b.items.map((it, j) => <li key={j}><RichText text={it} /></li>)}</ul>;
        if (b.type === "space") return <div key={i} className="h-3" />;
        return <p key={i} className="my-2 leading-relaxed text-slate-700"><RichText text={b.text} /></p>;
      })}
    </div>
  );
}
